import { render } from "./OfferProductComponent.vue?vue&type=template&id=2083e258"
import script from "./OfferProductComponent.vue?vue&type=script&lang=js"
export * from "./OfferProductComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/product/OfferProductComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2083e258"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2083e258', __exports__)) {
    api.reload('2083e258', __exports__)
  }
  
  module.hot.accept("./OfferProductComponent.vue?vue&type=template&id=2083e258", () => {
    api.rerender('2083e258', render)
  })

}


export default __exports__